﻿import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

type EllipsesWorkaroundData = {
    outerContainerRef: MutableRefObject<HTMLDivElement>;
    innerContainerRef: MutableRefObject<HTMLDivElement>;
    nameMaxWidth: number;
};

/**
 * Workaround for using ellipses with flexbox layout
 * Source: https://mui.com/components/menus/#limitations
 * Bug source: https://bugs.chromium.org/p/chromium/issues/detail?id=327437
 */
export function useEllipsesWorkaround(): EllipsesWorkaroundData {
    let theme = useTheme();
    let isSmallerScreen = useMediaQuery(theme.breakpoints.down('sm'));

    let outerContainerRef = useRef<HTMLDivElement | null>(null);
    let innerContainerRef = useRef<HTMLDivElement | null>(null);
    let [nameMaxWidth, setNameMaxWidth] = useState<number>(138);
    useEffect(() => {
        if (isSmallerScreen) {
            let outerClientRect = outerContainerRef.current.getBoundingClientRect();
            let innerClientRect = innerContainerRef.current.getBoundingClientRect();

            let diff = outerClientRect.width - innerClientRect.width;

            setNameMaxWidth((oldValue) => oldValue + diff);
        }
    }, [isSmallerScreen]);

    return {
        outerContainerRef,
        innerContainerRef,
        nameMaxWidth
    };
}